import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPanel.css';

function AdminPanel() {
  // Initialize state from localStorage
  const [apiKey, setApiKey] = useState(() => localStorage.getItem('adminApiKey') || '');
  const [isAuthenticated, setIsAuthenticated] = useState(() => Boolean(localStorage.getItem('adminApiKey')));
  const [formData, setFormData] = useState({
    address: '',
    num: '',
    unlocks_at: ''
  });
  const [message, setMessage] = useState({ text: '', type: '' });

  useEffect(() => {
    // Clear success messages after 3 seconds
    if (message.type === 'success') {
      const timer = setTimeout(() => {
        setMessage({ text: '', type: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleAuth = async (e) => {
    e.preventDefault();
    if (apiKey.trim()) {
      // Test the API key with a request
      try {
        await axios.get('https://uns-gift-574634440075.europe-west4.run.app/get/0x0000000000000000000000000000000000000000', {
          headers: {
            'x-api-key': apiKey
          }
        });
        // If no error, save the key and authenticate
        localStorage.setItem('adminApiKey', apiKey);
        setIsAuthenticated(true);
        setMessage({ text: 'Authenticated successfully', type: 'success' });
      } catch (error) {
        if (error.response?.status === 401) {
          setMessage({ text: 'Invalid API key', type: 'error' });
        } else {
          // Even if we get 404, that's fine - it means the key worked but address doesn't exist
          localStorage.setItem('adminApiKey', apiKey);
          setIsAuthenticated(true);
          setMessage({ text: 'Authenticated successfully', type: 'success' });
        }
      }
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminApiKey');
    setApiKey('');
    setIsAuthenticated(false);
    setFormData({ address: '', num: '', unlocks_at: '' });
    setMessage({ text: '', type: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        'https://uns-gift-574634440075.europe-west4.run.app/update',
        {
          address: formData.address,
          num: Number(formData.num),
          unlocks_at: parseInt(formData.unlocks_at) || null
        },
        {
          headers: {
            'x-api-key': apiKey,
            'Content-Type': 'application/json'
          }
        }
      );
      
      setMessage({ text: 'Gift updated successfully', type: 'success' });
      setFormData({ address: '', num: '', unlocks_at: '' });
    } catch (error) {
      if (error.response?.status === 401) {
        handleLogout();
        setMessage({ text: 'Session expired. Please login again.', type: 'error' });
      } else {
        setMessage({ 
          text: error.response?.data?.message || 'Error updating gift', 
          type: 'error' 
        });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (!isAuthenticated) {
    return (
      <div className="admin-container">
        <h1>Admin Panel</h1>
        <form onSubmit={handleAuth} className="auth-form">
          <input
            type="password"
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            placeholder="Enter API Key"
            required
          />
          <button type="submit">Authenticate</button>
        </form>
        {message.text && (
          <div className={`message ${message.type} ${message.type === 'success' ? 'fade-out' : ''}`}>
            {message.text}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h1>Gift Management</h1>
        <button onClick={handleLogout} className="logout-button">Logout</button>
      </div>
      <form onSubmit={handleSubmit} className="gift-form">
        <div className="form-group">
          <label>Wallet Address:</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="0x..."
            required
          />
        </div>
        <div className="form-group">
          <label>Number of Tokens:</label>
          <div className="token-input-group">
            <input
              type="number"
              name="num"
              value={formData.num}
              onChange={handleChange}
              placeholder="Enter number of tokens"
              required
            />
            {formData.num && (
              <div className="token-calculation">
                = {Number(formData.num) * 1000} UNS
              </div>
            )}
          </div>
        </div>
        <div className="form-group">
          <label>Unlock Timestamp:</label>
          <input
            type="number"
            name="unlocks_at"
            value={formData.unlocks_at}
            onChange={handleChange}
            placeholder="Enter unlock timestamp (optional)"
          />
          {formData.unlocks_at && (
            <div className="timestamp-preview">
              Unlocks at: {new Date(parseInt(formData.unlocks_at) * 1000).toLocaleString()}
            </div>
          )}
        </div>
        <button type="submit">Update Gift</button>
      </form>
      {message.text && (
        <div className={`message ${message.type} ${message.type === 'success' ? 'fade-out' : ''}`}>
          {message.text}
        </div>
      )}
    </div>
  );
}

export default AdminPanel; 